<template>
  <!-- Map🚀 -->
  <b-row class="match-height">
    <b-col
      cols="12"
    >
      <l-map
        ref="map"
        style="width: 100%; height: 200px; z-index: 0"
        :zoom="zoom"
        :center="center"
        :options="{scrollWheelZoom:false, zoomControl: true, attributionControl:false}"
      >
        <l-tile-layer :url="url" />
        <l-marker
          v-for="(markerFlooding, index) in markersflooding"
          :key="'markerFlooding'+index"
          ref="markerFlooding"
          :lat-lng="[markerFlooding.latitude, markerFlooding.longitude]"
          @click="getInfoFlooding(markerFlooding.devid, markerFlooding.devdesc, markerFlooding.devstate, markerFlooding.status, markerFlooding.lastupdate, markerFlooding.devbuilding)"
        >
          <l-icon v-if="markerFlooding.devstate === 0">
            <b-img
              :src="require('@/assets/images/icons/flooding/water-level-new1.png')"
              height="30"
            />
          </l-icon>
          <l-icon v-else-if="markerFlooding.devstate === '5'">
            <b-img
              :src="require('@/assets/images/icons/flooding/water-level-new2.gif')"
              height="30"
            />
          </l-icon>
          <l-icon v-else-if="markerFlooding.devstate === '10'">
            <b-img
              :src="require('@/assets/images/icons/flooding/water-level-new3.gif')"
              height="30"
            />
          </l-icon>
          <l-icon v-else-if="markerFlooding.devstate === '15'">
            <b-img
              :src="require('@/assets/images/icons/flooding/water-level-new4.gif')"
              height="30"
            />
          </l-icon>
          <l-icon v-else-if="markerFlooding.devstate === '20'">
            <b-img
              :src="require('@/assets/images/icons/flooding/water-level-new5.gif')"
              height="30"
            />
          </l-icon>
          <l-icon v-else-if="markerFlooding.devstate === '25'">
            <b-img
              :src="require('@/assets/images/icons/flooding/water-level-new6.gif')"
              height="30"
            />
          </l-icon>
          <l-icon v-else-if="markerFlooding.devstate === '30'">
            <b-img
              :src="require('@/assets/images/icons/flooding/water-level-new7.gif')"
              height="30"
            />
          </l-icon>
          <l-popup>
            <div>
              <b-table
                style="width: 15rem; font-size:14px; background-color: hsl(0, 0%, 0%, 1);"
                responsive="sm"
                :items="itemsFlooding"
                :fields="fieldsFlooding"
                small
                stacked
              >
                <template #cell(devstate)="data">
                  <span v-if="data.value === 0">
                    0 ซม.
                  </span>
                  <span v-if="data.value === 1">
                    5 ซม.
                  </span>
                  <span v-if="data.value === 2">
                    10 ซม.
                  </span>
                  <span v-if="data.value === 3">
                    15 ซม.
                  </span>
                  <span v-if="data.value === 4">
                    20 ซม.
                  </span>
                  <span v-if="data.value === 5">
                    25 ซม.
                  </span>
                  <span v-if="data.value === 6">
                    30 ซม.
                  </span>
                </template>
              </b-table>
            </div>
          </l-popup>
        </l-marker>
        <l-marker
          v-for="(markerVMS, index) in markersVMS.slice(2,5)"
          :key="'markerVMS'+index"
          ref="markerVMS"
          :lat-lng="[markerVMS.Latitude, markerVMS.Longitude]"
        >
          <l-icon v-if="markerVMS.isset === 0">
            <b-img
              :src="require('@/assets/images/icons/flooding/Floodinghighoff.png')"
              height="30"
            />
          </l-icon>
          <l-icon v-else-if="markerVMS.isset === 1">
            <b-img
              :src="require('@/assets/images/icons/flooding/Floodinghighon.gif')"
              height="30"
            />
          </l-icon>
        </l-marker>
      </l-map>
    </b-col>
  </b-row>
</template>

<script>
/* eslint-disable global-require */
import {
  BRow, BCol,
  //  BCard,
  VBModal, BImg,
  BTable,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'
import {
  LMap, LTileLayer, LMarker, LIcon, LPopup,
} from 'vue2-leaflet'
import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

export default {
  components: {
    // BCard,
    BRow,
    BCol,
    LMap,
    LMarker,
    LIcon,
    BImg,
    LTileLayer,
    LPopup,
    BTable,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '',
      zoom: 16,
      center: [18.839867, 98.973773],
      staticAnchor: [16, 37],
      markers: [],
      markersflooding: [],
      markersVMS: [],
      itemsFlooding: [],
      minZoom: -10,
      fieldsFlooding: [
        {
          key: 'devbuilding', label: 'ฝั่ง:',
        },
        {
          key: 'devdesc', label: 'ชื่อ:',
        },
        {
          key: 'devstate', label: 'ระดับน้ำ:',
        },
        {
          key: 'status', label: 'สถานะ:',
        },
        {
          key: 'lastupdate', label: 'อัพเดต:',
        },
      ],
    }
  },
  computed: {
  },
  created() {
    setInterval(() => {
      this.getFlooding()
      this.getFloodingVMS()
    }, 8000)
  },
  mounted() {
    this.getFlooding()
    this.getWayCCTV()
    this.getFloodingVMS()
  },
  methods: {
    getWayCCTV() {
      axios
        .post('/getWayCCTVDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.center = []
          this.center.push(response.data[0].latitude)
          this.center.push(response.data[0].longitude)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getFlooding() {
      axios
        .post('/imgFlooding', { wid: this.$route.query.wid })
        .then(response => {
          this.markersflooding = []
          this.markersflooding = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getFloodingVMS() {
      axios
        .post('/vmsFlooding', { wid: this.$route.query.wid })
        .then(response => {
          this.markersVMS = response.data
        })
    },
    getInfoFlooding(devid, devdesc, devstate, status, lastupdate, devbuilding) {
      this.itemsFlooding = []
      this.itemsFlooding.push({
        devid,
        devdesc,
        devstate,
        status,
        lastupdate,
        devbuilding,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-flatpicker.scss';
.table-responsive{
   font-size: 13px;
}
.table th{
   padding: 0.72rem;
}
.table td{
   padding: 0.72rem;
}
.vue2leaflet-map{
  &.leaflet-container{
    height: 500px;
  }
}
.leaflet-popup-content {
  margin: 10px 10px;
}
.leaflet-container a.leaflet-popup-close-button {
  padding: 0 0 0 0
}

.transparent-card {
  font-size:18px;
  background-color:rgba(0, 0, 0, 0.5);
  color:#ffffff;
  height: 120px;
  border: 3px solid #ffffff;
  border-radius: 20px;
}
</style>
